<mat-toolbar>{{'Add New Observation' | translate | async}}</mat-toolbar>
<div class="Dialog-body">
  <form>
    

     <!-- <mat-form-field appearance="DBSS" style="width: 400px;">
      <mat-label>Date</mat-label>
      <input matInput [matDatepicker]="picker" type="picker" [(ngModel)]="observationDate" [ngModelOptions]="{standalone: true}">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field> -->
    <mat-form-field appearance="fill" style="width: 400px;">
      <mat-label>{{'Date' | translate | async}}</mat-label>
      <input matInput [matDatepicker]="picker" type="text" [(ngModel)]="observationDate" [ngModelOptions]="{standalone: true}">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field class="DBSS">
      <mat-select placeholder="{{'State' | translate | async}}" (selectionChange)="stateChanged($event)"  [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required>            
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select>  
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
  </mat-form-field>
    
    <mat-form-field class="DBSS">
      <mat-select placeholder="{{'Department' | translate | async}}" (selectionChange) = "GetActiveWorkAreasForDropDownListChanged()"  [(ngModel)]="inputValueDepartment" name="Department">            
        <mat-option *ngFor="let Department of departmentlist_" [value]="Department.ID">
          {{Department.DepartmentName}} </mat-option>
        </mat-select> 
    </mat-form-field>
    
    <mat-form-field class="DBSS">
      <mat-select placeholder="{{'Work Area' | translate | async}}"   [(ngModel)]="inputValueWorkArea" name="Workarea" [(ngModel)]="inputValueWorkArea">            
        <mat-option *ngFor="let Workarea of WorkList" [value]="Workarea.Id">
          {{Workarea.Name}} </mat-option>
        </mat-select> 
    </mat-form-field>
    
    <mat-form-field class="DBSS">
      <input matInput type="text" placeholder="{{'Task Observed' | translate | async}}"  name = "Taskobserved"  [(ngModel)]="inputValueTaskObserved">  
    </mat-form-field>

    <div class="buttonbelow">
       
      <button mat-button  mat-raised-button (click) ="CreateNewInspection()">{{'Submit' | translate | async}}</button> 
      <button mat-button (click)="DialogClose()">{{"Cancel" | translate | async}}</button> 
    </div>
</form>

</div>
